<template>
  <div v-if="item && !item.hidden && !item.iscloneResource" class="menu-container">
    <template v-if="!item.hidden && item.isShowMenu && item.path && item.resourceType === 1">
      <app-link :to="resolvePath(item.path)">
        <el-menu-item :index="resolvePath(item.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item
            :resourceKey="item.resourceKey"
            v-if="item.meta"
            :indexNum="indexNum"
            :title="getName(item)"
            :icon="getIcon(indexNum)"
          />
        </el-menu-item>
      </app-link>
    </template>
    <!--hasOneShowingChild(item.children,item) 判断是否仅有一个子集； onlyOneChild.children判断子集是否还有子集；onlyOneChild.noShowingChildren：判断子集是否都是hidden=true -->
    <!-- <template v-else-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item
            v-if="onlyOneChild.meta"
            :indexNum="indexNum"
            :title="getName(onlyOneChild)"
            :resourceKey="onlyOneChild.resourceKey"
            :icon="getIcon(indexNum)"
          />
        </el-menu-item>
      </app-link>
    </template> -->
    <template v-else>
      <el-submenu v-if="hasAtLeastOneShowingChild(item.children, item)" :index="resolvePath(item.path) + item.resourceKey">
        <!-- :style="{'padding-left': ((indexNum - 1) * 8) + 'px!important'}" -->
        <div slot="title">
          <item
            v-if="item && (item.resourceKey || item.noPermission)"
            :title="getName(item, 'item')"
            :routeInfo="item"
            :indexNum="indexNum"
            :icon="getIcon(indexNum)"
            :resourceKey="item.resourceKey"
          />
        </div>
        <template v-for="(child, ind) in item.children">
          <span v-if="!child.hidden" :key="`${ind}_${child.resourceKey}_${child.path}`">
            <sidebar-item
              v-if="child.children && child.children.length > 0 && hasAtLeastOneShowingChild(child.children, child)"
              :is-nest="true"
              :item="child"
              :indexNum="indexNum + 1"
              :key="`${child.path}_${ind}_${child.resourceKey}`"
              :base-path="resolvePath(child.path)"
              class="nest-menu" />
            <app-link v-else-if="child.path" :to="resolvePath(child.path)" :key="`${child.resourceKey}_${ind}_${child.path}`">
              <!-- :style="{'padding-left': ((indexNum + 1) * 8) + 'px!important'}" -->
              <el-menu-item :index="resolvePath(child.path)">
                <item
                  v-if="child.meta"
                  :title="getName(child, ind)"
                  :routeInfo="child"
                  :indexNum="indexNum + 1"
                  :icon="getIcon(indexNum)"
                  :resourceKey="child.resourceKey"
                />
              </el-menu-item>
            </app-link>
          </span>
        </template>
      </el-submenu>
      <template v-else-if="item.path && item.resourceType === 1">
        <app-link :to="resolvePathClass(item.path)">
          <!-- :style="{'padding-left': (indexNum* 8) + 'px!important'}"> -->
          <el-menu-item :index="resolvePath(item.path)" :class="{'submenu-title-noDropdown':!isNest}">
            <item
              :resourceKey="item.resourceKey"
              v-if="item.meta"
              :routeInfo="item"
              :indexNum="indexNum"
              :title="getName(item)"
              :icon="getIcon(indexNum)"
            />
          </el-menu-item>
        </app-link>
      </template>
    </template>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '../utils'
import Item from './Item'
import AppLink from './Link'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
    indexNum: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState({
      switchs: (_flag) => _flag.permission.highQualityFilterSwitch,
    }),
    ...mapGetters(['refreshUnreadCount']),
    // onlyOneChild () {
    //   return this.getOnlyOneChildrenRouter(this.item.children, this.item)
    // }
  },
  methods: {
    doGetFunc(item, index) {
      const _this = this
      const newItem = item
      // vuex里面对于路由的item的refreshAttr对于的值为属性的这个值更新了，则也要重新获取数据
      if (item && item.getFunc && (!item.extra || (item.refreshAttr && _this[item.refreshAttr] !== item[item.refreshAttr]))) {
        if (item.refreshAttr) {
          item[item.refreshAttr] = _this[item.refreshAttr]
        }
        item.getFunc().then((res) => {
          newItem.extra = res.data
          typeof index === 'string' ? _this.$set(_this, index, newItem) : _this.$set(_this.item.children, index, newItem)
        })
      }
    },
    hasAtLeastOneShowingChild(children = []) {
      const showingChildren = children.filter((item) => !item.hidden)
      if (showingChildren.length > 0) {
        return true
      }
      return false
    },
    // hasOneShowingChild (children = []) {
    //   const showingChildren = children.filter(item => !item.hidden)
    //   // Show parent if there are no child router to display
    //   if (showingChildren.length === 1) {
    //     return true
    //   }
    //   return false
    // },
    // getOnlyOneChildrenRouter (children = [], parent) {
    //   let obj = null
    //   const showingChildren = children.filter(item => {
    //     if (item.hidden) {
    //       return false
    //     } else {
    //       // Temp set(will be used if only has one showing child)
    //       obj = item
    //       return true
    //     }
    //   })
    //   // Show parent if there are no child router to display
    //   if (showingChildren.length === 0) {
    //     obj = { ...parent, noShowingChildren: true }
    //   }
    //   return {
    //     ...obj,
    //     pName: parent.resourceName || parent.meta && parent.meta.title
    //   }
    // },
    resolvePath(routePath) {
      if (!routePath) {
        return ''
      }
      if (this.isExternalLink(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },
    isExternalLink(routePath) {
      return isExternal(routePath)
    },
    resolvePathClass(routePath) {
      if (!routePath) {
        return ''
      }
      if (isExternal(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath)
    },
    getIcon(idx) {
      if (idx === 1) {
        return 'BLM-icon-menu-label'
      } else {
        return ''
      }
    },
    // getIcon(item, item1 = {}) {
    //   let { meta } = item;
    //   const isFirst = item.isFirst || item1.isFirst
    //   const icon1 = item1 && item1.meta && item1.meta.icon;
    //   if (isFirst) {
    //     return meta && meta.icon || (icon1 || 'el-icon-menu')
    //   } else return '';
    // },
    getName(item, index) {
      const { hasFunc, getFunc } = item
      if (hasFunc && (typeof getFunc === 'function') && (index || index === 0)) {
        this.doGetFunc(item, index)
      }
      return item.pName || item.resourceName || (item && item.meta && item.meta.title)
    },
  },
}
</script>

<style lang="scss">
$--color-primary: #276BEC;
$--background-color-active: #F5F7FA;
$--color-text-primary: rgba(0, 0, 0, 0.85);
$--color-text-regular:  rgba(0, 0, 0, 0.65);
$--color-text-secondary: rgba(0, 0, 0, 0.45);
$--color-text-placeholder: rgba(0, 0, 0, 0.25);
$--font-size-base: 14px;
$--font-size-extra-small: 12px;
$--font-weight-primary: 500;
$--font-weight-regular: 400;

#app .common-menu,#root .common-menu {
  .menu-container {
    .el-menu-item {
      display: flex;
      align-items: center;
    }
    .group-name {
      font-size: $--font-size-extra-small;
      color: $--color-text-placeholder;
      padding-left: 8px;
      margin-bottom: 12px;
      height: 24px;
      line-height: 24px;
    }
    .item-text {
      color: $--color-text-primary;
      font-size: $--font-size-base;
      font-weight: $--font-weight-primary;
      display: inline-block !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
    }
    .el-submenu__title .item-text {
      max-width: 100px !important;
    }
    .el-menu-item.submenu-title-noDropdown .item-text {
      max-width: 120px !important;
    }
    .el-submenu .el-menu.el-menu--inline {
      .BLM-icon-menu-label {
        display: none;
      }
      .el-menu-item, .el-submenu__title {
        padding-left: 28px !important;
        padding-right: 8px !important;
        .item-text {
          font-weight: $--font-weight-regular;
        }
      }
      .el-menu-item .item-text {
        max-width: 120px !important;
      }
      .el-submenu .el-menu.el-menu--inline {
        width: 122px !important;
        margin-left: 34px;
        padding-left: 0px;
        .el-menu-item {
          padding-left: 8px !important;
          width: 122px !important;
          height: 32px;
          line-height: 32px;
          margin-bottom: 4px !important;
          .item-text {
            font-weight: $--font-weight-regular;
            max-width: 106px !important;
          }
        }
        & > span:last-child {
          .el-menu-item {
            margin-bottom: 14px !important;
          }
        }
      }
    }

    .el-submenu__title,
    .el-menu-item {
      width: 156px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 0px;
      margin-bottom: 14px;
      padding-left: 8px !important;
      box-sizing: border-box;
      height: 32px;
      line-height: 32px;
      color: $--color-text-primary;
      &:hover {
        background: unset !important;
        color: $--color-primary !important;
        [class*="el-icon-"],[class*="BLM-icon-"] {
          color: $--color-primary !important;
        }
        .item-text {
          color: $--color-primary !important;
        }
      }
      &.is-active {
        background: $--background-color-active !important;
        border-radius: 4px;
        color: $--color-primary !important;
        .item-text,[class*="el-icon-"],[class*="BLM-icon-"] {
          color: $--color-primary !important;
        }
      }
      [class*="el-icon-"],[class*="BLM-icon-"]{
        font-size: 16px !important;
        width: 16px !important;
        margin-right: 8px !important;
        color: $--color-text-secondary;
      }
       // 菜单折叠箭头
      .el-submenu__icon-arrow.el-icon-arrow-down {
        right: 0;
      }
      .BLM-icon-menu-label {
        margin-right: 4px !important;
      }
    }
    .el-submenu {
      width: 100% !important;
      .el-menu {
        width: 100% !important;
        box-sizing: border-box;
      }
    }
    .has-bragger-item {
      display: inline-block;
      .item-text.item-text-flex {
        display: flex !important;
        flex: 1;
        >.item-text-wrap {
          display: block;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .bragger{
        margin-left:10px;
        background-color: #f56c6c;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        padding: 3px 6px;
      }
    }
  }
  .menu-container + .menu-container {
    .group-name {
      margin-top: 22px;
      position: relative;
      &::before {
        content: '';
        display: block;
        height: 1px;
        width: 152px;
        background: #E5E5E5;
        position: absolute;
        top: -12px;
        left: 0;
      }
    }

  }
  // > .el-menu {
  //   > .menu-container {
  //     >.el-submenu {
  //       > .el-submenu__title {
  //         color: #000; //一级菜单栏 颜色
  //       }
  //     }
  //     >span > .submenu-title-noDropdown {
  //       color: #000;//一级菜单栏 颜色
  //     }
  //   }
  // }
}
// #app .sidebar-container .menu-container .nest-menu .el-submenu > .el-submenu__title,
// #app .sidebar-container .menu-container .el-submenu .el-menu-item {
//   min-width: 100px !important;
// }
#app .mobile.hideSidebar .sidebar-container {
  transform: inherit;
}
.scrollbar-right {
  .recommond-tags {
    margin-left: 4px;
    // min-width: 30px;
    > i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color:#FF5964;
      box-sizing: border-box;
      margin-bottom: 3px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #FFFFFF !important;
      text-align: center;
      font-weight: 500;
      font-style: normal;
      border-radius: 4px;
    }
    > i + i {
      margin-left: 3px;
    }
  }
}

</style>
